var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99811 4.2467L3.26632 6.46606C3.54316 6.95053 3.68158 7.19277 3.68158 7.45833C3.68158 7.7239 3.54316 7.96614 3.26632 8.45061L1.99811 10.67C0.759807 12.837 0.140655 13.9205 0.62348 14.4578C1.1063 14.9952 2.24961 14.495 4.53623 13.4946L14.1452 9.29065L14.1452 9.29065C15.9407 8.50511 16.8384 8.11235 16.8384 7.45833C16.8384 6.80432 15.9407 6.41155 14.1452 5.62602L4.53624 1.4221C2.24962 0.421707 1.1063 -0.0784915 0.62348 0.458828C0.140655 0.996147 0.759808 2.07966 1.99811 4.2467Z",
    fill: "#006AAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportarrow);
export default __webpack_public_path__ + "static/media/reportarrow.ad066560a5d47f077e2dfccaf82fb5a8.svg";
export { ForwardRef as ReactComponent };